import { withPublicAssetUrl } from '@lib/utils/cdn'
import { useIntl } from 'react-intl'

import styles from './grammarly-coda.module.scss'

const GridShape = () => {
  const intl = useIntl()

  return (
    <img
      src={`${withPublicAssetUrl('background-asset/coda-grammarly/grid.svg')}`}
      alt={intl.formatMessage({
        id: 'backgroundAsset.gridShape.altText',
        description: 'Background Asset - Grid Shape - Alt Text',
        defaultMessage: 'Grid shape',
      })}
      className={styles.gridShape}
    />
  )
}

const CodaShape = () => {
  const intl = useIntl()

  return (
    <>
      <img
        src={`${withPublicAssetUrl('background-asset/coda-grammarly/coda.svg')}`}
        alt={intl.formatMessage({
          id: 'backgroundAsset.codaShape.altText',
          description: 'Background Asset - Coda Shape - Alt Text',
          defaultMessage: 'Coda shape',
        })}
        className={styles.codaShapeIcon}
      />
      <div className={styles.codaSpacer}></div>
    </>
  )
}

const GrammarlyShape = () => {
  const intl = useIntl()

  return (
    <>
      <div className={styles.grammarlySpacer} />
      <img
        src={`${withPublicAssetUrl('background-asset/coda-grammarly/grammarly.svg')}`}
        alt={intl.formatMessage({
          id: 'backgroundAsset.grammarlyShape.altText',
          description: 'Background Asset - Grammarly Shape - Alt Text',
          defaultMessage: 'Grammarly shape',
        })}
        className={styles.grammarlyShapeIcon}
      />
    </>
  )
}

export const getGrammarlyCodaAsset = () => {
  return {
    top: GrammarlyShape,
    background: GridShape,
    bottom: CodaShape,
  }
}
